import { render, staticRenderFns } from "./IndexAnggaran.vue?vue&type=template&id=ffd191f6&"
import script from "./IndexAnggaran.vue?vue&type=script&lang=js&"
export * from "./IndexAnggaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports